import cn from './cn'
import tw from './tw'
export default {
    'zh-cn': cn,
    'zh-tw': tw
}